import React from 'react'
import { Button } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

interface ToShopOnlineButtonProp {
    content: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => any;
  }

const toShopOnlinebutton = ({ content, onClick }: ToShopOnlineButtonProp) => {
  return (
    <React.Fragment>
    <Button
      sx = {{
        backgroundColor: "#ffffff",
        border: "solid 1px #D7282F",
        color: "#D7282F",
        borderRadius: "50px",
        paddingLeft: "20px",
        paddingRight: "20px",
        height: "50px",
        marginTop: "20px",
        marginBottom: "20px",
        marginRight: "10px",
        fontSize: "25px",
        fontWeight: "bold",
        }}
    
      onClick={onClick}
    >
        <ShoppingCartIcon sx={{fontSize: "25px", marginRight: "10px", marginBottom: "5px"}} />
        <span>{content}</span>
    </Button>
    </React.Fragment>
  );
};

export default toShopOnlinebutton
